/* logo-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */
import "./logo-wrapper.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useThemeObserver } from '@atlaskit/tokens';
var styles = {
  root: "_1e0c1o8l _vwz4idpf"
};

// These styles set the `color` property so that the child SVG can inherit the correct text color using "currentColor"
var logoTextColorMap = {
  light: "_syazqlpt",
  dark: "_syazz6c6"
};
var sizeMap = {
  xxsmall: "_4t3i7vkz",
  xsmall: "_4t3igktf",
  small: "_4t3i1tcg",
  medium: "_4t3izwfg",
  large: "_4t3i1ylp",
  xlarge: "_4t3ickbl"
};

/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */
var appearanceMap = {
  brand: "_1b3i18uv _9aea18uv _1wyc1fxt",
  neutral: "_1b3i15cr _9aea1fxt _1wyc1fxt",
  inverse: "_1b3i1fxt _9aea15cr _1wyc15cr",
  legacy: "_1b3iu67f _9aeadoyu _1wycu67f"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */
/* eslint-enable @atlaskit/ui-styling-standard/no-unsafe-values */

export function LogoWrapper(_ref) {
  var _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'small' : _ref$size,
    svg = _ref.svg,
    customThemeSvg = _ref.customThemeSvg,
    label = _ref.label,
    userDefinedTestId = _ref.testId,
    customIconColor = _ref.iconColor,
    customTextColor = _ref.textColor;
  var _useThemeObserver = useThemeObserver(),
    colorMode = _useThemeObserver.colorMode;
  var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
  var isCustomThemed = customThemeSvg && (customIconColor || customTextColor);
  return /*#__PURE__*/React.createElement("span", {
    style: {
      // Nav v3 passes in "inherit" incorrectly for iconColor, so we fall back to textColor when this happens.
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
      '--themed-icon-color': customIconColor === 'inherit' ? customTextColor : customIconColor,
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
      '--themed-text-color': customTextColor || 'inherit'
    },
    "data-testid": testId
    // For logos, the label will always be present and will never be an empty string, so we can always set these aria attributes.
    ,
    "aria-label": label,
    role: label ? 'img' : undefined,
    "aria-hidden": label === '' ? true : undefined
    // We are using dangerouslySetInnerHTML here to tell React not to track changes to the SVG elements.
    // This is because the SVG elements are static and will not change, so we get a little performance benefit by
    // bypassing React.
    ,
    dangerouslySetInnerHTML: {
      __html: isCustomThemed ? customThemeSvg : svg
    },
    className: ax([styles.root,
    // Setting the color so that the SVG can inherit the correct text color using "currentColor"
    logoTextColorMap[colorMode !== null && colorMode !== void 0 ? colorMode : 'light'], sizeMap[size], appearanceMap[appearance]])
  });
}